export default __webpack_public_path__ + "static/media/menu_template_icon.4d943501.svg";